import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { grandIslandConfig } from "./data";

export default function GrandIslandPage() {
  return <CityPageTemplate config={grandIslandConfig} />;
}